import { AssetWithHighlight, SharedEventView } from './shared-event-view'

export const MovementEventView = ({ assets }: Props) => {
  return <SharedEventView assets={assets} isEventMove />
}

type Props = {
  assets: AssetWithHighlight[]
}
